import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-black" data-testid="about-page">
      <SEO title="About" description="Learn about Check On Yo Peoples TV, our Cincinnati coverage, editorial mission, and how to contact our team." type="website" />
      <Header />
      <div className="max-w-5xl mx-auto px-4 py-12 text-gray-300">
        <div className="grid gap-8 lg:grid-cols-[1.35fr_0.95fr] items-start">
          <section className="space-y-6">
            <span className="inline-flex items-center px-3 py-1 text-[11px] font-bold uppercase tracking-[0.28em] text-yellow-400 border border-yellow-500/30 bg-yellow-500/10" data-testid="about-page-kicker">
              Independent Cincinnati Publisher
            </span>
            <div>
              <h1 className="text-4xl sm:text-5xl font-black text-white mb-4">About Check On Yo Peoples TV</h1>
              <p className="text-base sm:text-lg text-gray-300 leading-relaxed max-w-3xl">
                Check On Yo Peoples TV (COYP) is a Cincinnati-focused digital publisher covering local news, street-level updates, viral moments, and community conversation.
                We aim to publish stories that are timely, readable, and useful for people who want to stay tapped into what is happening across the city.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              <div className="border border-[#222] bg-[#0d0d0d] p-5" data-testid="about-mission-card">
                <h2 className="text-white font-bold text-lg mb-2">Our mission</h2>
                <p className="text-sm leading-relaxed text-gray-400">
                  Spotlight the stories Cincinnati is already talking about and package them in a way that is fast to follow, easy to share, and grounded in clear sourcing.
                </p>
              </div>
              <div className="border border-[#222] bg-[#0d0d0d] p-5" data-testid="about-coverage-card">
                <h2 className="text-white font-bold text-lg mb-2">What we cover</h2>
                <p className="text-sm leading-relaxed text-gray-400">
                  Cincy Feed, Worldstar-style video culture, and Check Your Claims stories that help readers sort through what is real, what is developing, and what needs more context.
                </p>
              </div>
            </div>

            <div className="space-y-4 text-sm leading-relaxed">
              <p>
                We value original framing, clear headlines, fast updates, and corrections when needed. When a story is still developing, we aim to say that plainly instead of overstating certainty.
              </p>
              <p>
                Advertising helps support the site, but ads do not decide our story selection. You can read more about how we handle sourcing, updates, and corrections in our{' '}
                <Link to="/editorial-policy" className="text-yellow-400 hover:text-yellow-300 underline-offset-4 hover:underline" data-testid="about-editorial-link">
                  Editorial Policy
                </Link>
                .
              </p>
              <p>
                Have a tip, correction, business inquiry, or a story worth checking out? Visit our{' '}
                <Link to="/contact" className="text-yellow-400 hover:text-yellow-300 underline-offset-4 hover:underline" data-testid="about-contact-link">
                  Contact page
                </Link>
                .
              </p>
            </div>
          </section>

          <aside className="space-y-4">
            <div className="border border-yellow-500/25 bg-gradient-to-br from-yellow-500/10 via-[#0f0f0f] to-black p-6" data-testid="about-standards-panel">
              <h2 className="text-white font-bold text-xl mb-3">Reader trust standards</h2>
              <ul className="space-y-3 text-sm text-gray-300 leading-relaxed list-disc pl-5">
                <li>We aim to identify stories clearly, keep timestamps visible, and avoid misleading headlines.</li>
                <li>We distinguish quick updates from longer writeups and revise posts when better information comes in.</li>
                <li>We keep public contact information available so readers can reach us about tips, corrections, and policy questions.</li>
              </ul>
            </div>

            <div className="border border-[#222] bg-[#0d0d0d] p-6" data-testid="about-publisher-panel">
              <h2 className="text-white font-bold text-xl mb-3">Publisher details</h2>
              <dl className="space-y-3 text-sm text-gray-400">
                <div>
                  <dt className="text-gray-500 uppercase tracking-[0.2em] text-[11px] mb-1">Brand</dt>
                  <dd className="text-white">Check On Yo Peoples TV</dd>
                </div>
                <div>
                  <dt className="text-gray-500 uppercase tracking-[0.2em] text-[11px] mb-1">Coverage focus</dt>
                  <dd>Cincinnati news, local culture, and community conversation</dd>
                </div>
                <div>
                  <dt className="text-gray-500 uppercase tracking-[0.2em] text-[11px] mb-1">Contact</dt>
                  <dd><a href="mailto:contact@coyp.me" className="text-yellow-400 hover:text-yellow-300">contact@coyp.me</a></dd>
                </div>
              </dl>
            </div>
          </aside>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;
